import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Favorite} from '@models/favorite';
import {AdService} from '@services/ad.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {EMPTY_FAVORITE} from '@models/empty';

@Component({
    selector: 'app-duplicate',
    templateUrl: './duplicate.component.html',
    styleUrls: ['./duplicate.component.scss']
})
export class DuplicateComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
    });
    favorite: Favorite = EMPTY_FAVORITE;
    loading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        public dialogRef: MatDialogRef<DuplicateComponent>,
        public trackingService: TrackingService) {

        this.favorite = Object.assign({}, data.favorite);
        this.favoriteForm.setValue({title: 'Copie de ' + this.favorite.title});
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid) {
            this.trackingService.addFavorite();
            if (this.favoriteForm.get('title').value) {
                this.favorite.title = this.favoriteForm.get('title').value;
                this.loading = true;
                this.adService.dupplicateFavorites(this.favorite).subscribe((favoriteId) => {
                    this.loading = false;
                    this.dialogRef.close(favoriteId);
                }, error => {
                    console.log('Error');
                    console.log(error);
                });
            } else {
                this.dialogRef.close(false);
            }
        }
    }
}
